export default {
  badge: "Placa"
  , close: "Cerrar"
  , dataIterator: {
    noResultsText: "Ningún elemento coincide con la búsqueda"
    , loadingText: "Cargando..."
  }
  , dataTable: {
    itemsPerPageText: "Registros por página:"
    , ariaLabel: {
      sortDescending: "Orden descendente."
      , sortAscending: "Orden ascendente."
      , sortNone: "Sin ordenar."
      , activateNone: "Pulse para quitar orden."
      , activateDescending: "Pulse para ordenar de forma descendente."
      , activateAscending: "Pulse para ordenar de forma ascendente."
    }
    , sortBy: "Ordenado por"
  }
  , dataFooter: {
    itemsPerPageText: "Elementos por página:"
    , itemsPerPageAll: "Todos"
    , nextPage: "Página siguiente"
    , prevPage: "Página anterior"
    , firstPage: "Primera página"
    , lastPage: "Última página"
    , pageText: "Mostrando registros del {0} al {1} de un total de {2} registros"
  }
  , datePicker: {
    itemsSelected: "{0} seleccionados"
    , nextMonthAriaLabel: "Próximo mes"
    , nextYearAriaLabel: "Próximo año"
    , prevMonthAriaLabel: "Mes anterior"
    , prevYearAriaLabel: "Año anterior"
  }
  , noDataText: "No hay datos disponibles"
  , carousel: {
    prev: "Visual anterior"
    , next: "Visual siguiente"
    , ariaLabel: { delimiter: "Visual {0} de {1}" }
  }
  , calendar: { moreEvents: "{0} más" }
  , fileInput: {
    counter: "{0} archivos"
    , counterSize: "{0} archivos ({1} en total)"
  }
  , timePicker: {
    am: "AM"
    , pm: "PM"
  }
  , pagination: {
    ariaLabel: {
      wrapper: "Navegación de paginación"
      , next: "Página siguiente"
      , previous: "Página anterior"
      , page: "Ir a la página {0}"
      , currentPage: "Página actual, página {0}"
    }
  }
  , rating: { ariaLabel: { icon: "Puntuación {0} de {1}" } }
};



// WEBPACK FOOTER //
// ./src/assets/locale/es.js